module.exports = __webpack_public_path__ + "img/white-ball.f9535860.svg";